
export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0A1628] mb-8">Aviso Legal</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p className="text-sm text-gray-500">Última actualización: 6 de febrero de 2026</p>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">1. Datos Identificativos</h2>
            <p>
              En cumplimiento con el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad 
              de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:
            </p>
            <div className="mt-4 bg-gray-50 p-6 rounded-lg">
              <ul className="space-y-2">
                <li><strong>Denominación social:</strong> PreBedAI</li>
                <li><strong>NIF/CIF:</strong> [Número de identificación fiscal]</li>
                <li><strong>Domicilio social:</strong> [Dirección completa]</li>
                <li><strong>Correo electrónico:</strong> info@prebedai.com</li>
                <li><strong>Teléfono:</strong> [Número de teléfono]</li>
                <li><strong>Sitio web:</strong> https://prebedai.com</li>
                <li><strong>Registro Mercantil:</strong> [Datos de inscripción si aplica]</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">2. Objeto</h2>
            <p>
              El presente Aviso Legal regula el uso y utilización del sitio web https://prebedai.com, 
              del que es titular PreBedAI.
            </p>
            <p className="mt-4">
              La navegación por el sitio web atribuye la condición de usuario del mismo e implica la aceptación 
              plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">3. Condiciones de Uso</h2>
            <p>
              El acceso y utilización del sitio web es gratuito, salvo en lo relativo al coste de la conexión 
              a través de la red de telecomunicaciones suministrada por el proveedor de acceso contratado por el usuario.
            </p>
            <p className="mt-4">
              El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que PreBedAI ofrece 
              a través de su sitio web y, con carácter enunciativo pero no limitativo, a no emplearlos para:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público</li>
              <li>Difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico-ilegal, de apología del terrorismo o atentatorio contra los derechos humanos</li>
              <li>Provocar daños en los sistemas físicos y lógicos de PreBedAI, de sus proveedores o de terceras personas</li>
              <li>Introducir o difundir virus informáticos o cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar daños</li>
              <li>Intentar acceder y, en su caso, utilizar las cuentas de correo electrónico de otros usuarios y modificar o manipular sus mensajes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">4. Contenidos</h2>
            <p>
              PreBedAI se reserva el derecho a modificar, suspender o interrumpir, en cualquier momento y sin 
              necesidad de previo aviso, la accesibilidad al sitio web o a cualquiera de sus contenidos.
            </p>
            <p className="mt-4">
              Los contenidos ofrecidos a través del sitio web tienen únicamente una finalidad informativa y, 
              en ningún caso, deben entenderse como sustitutivos del consejo médico profesional.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">5. Propiedad Intelectual e Industrial</h2>
            <p>
              El sitio web, incluyendo a título enunciativo pero no limitativo su programación, edición, 
              compilación y demás elementos necesarios para su funcionamiento, los diseños, logotipos, 
              texto y/o gráficos, son propiedad de PreBedAI o, en su caso, dispone de licencia o autorización 
              expresa por parte de los autores.
            </p>
            <p className="mt-4">
              Todos los contenidos del sitio web se encuentran debidamente protegidos por la normativa de 
              propiedad intelectual e industrial, así como inscritos en los registros públicos correspondientes.
            </p>
            <p className="mt-4">
              Queda expresamente prohibido crear enlaces de hipertexto (links) a cualquier elemento integrante 
              de las páginas web del sitio web sin la autorización de PreBedAI, siempre que no sean a una página 
              web que no requiera identificación o autenticación para su acceso, o el mismo esté restringido.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">6. Exclusión de Garantías y Responsabilidad</h2>
            <p>
              PreBedAI no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza 
              que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de 
              disponibilidad del sitio web o la transmisión de virus o programas maliciosos o lesivos en los 
              contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
            </p>
            <p className="mt-4 font-bold">
              PreBedAI es una herramienta de apoyo a la toma de decisiones clínicas. La responsabilidad final 
              de las decisiones médicas y de gestión hospitalaria recae siempre en los profesionales sanitarios.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">7. Enlaces Externos</h2>
            <p>
              Las páginas del sitio web podrían proporcionar enlaces a otros sitios web de terceros que PreBedAI 
              considera pueden ser de interés para los usuarios. PreBedAI no se responsabiliza del contenido de 
              estos sitios web, ni se sitúa en una posición de garante ni/o de parte ofertante de los servicios 
              y/o información que se puedan ofrecer a terceros a través de los enlaces de terceros.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">8. Protección de Datos</h2>
            <p>
              PreBedAI cumple con las directrices de la normativa vigente en materia de protección de datos de 
              carácter personal, el Reglamento (UE) 2016/679 de 27 de abril de 2016 (RGPD) y la Ley Orgánica 
              3/2018, de 5 de diciembre (LOPDGDD).
            </p>
            <p className="mt-4">
              Para más información, consulte nuestra 
              <a href="/politica-privacidad" className="text-[#6D28D9] hover:underline ml-1">Política de Privacidad</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">9. Cookies</h2>
            <p>
              El sitio web utiliza cookies propias y de terceros. Para más información, consulte nuestra 
              <a href="/politica-cookies" className="text-[#6D28D9] hover:underline ml-1">Política de Cookies</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">10. Legislación Aplicable y Jurisdicción</h2>
            <p>
              Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web 
              o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se 
              someten expresamente las partes.
            </p>
            <p className="mt-4">
              Para cualquier controversia que pudiera derivarse del acceso o uso del sitio web, PreBedAI y el 
              usuario se someten a los Juzgados y Tribunales de [Ciudad], renunciando expresamente al fuero que 
              pudiera corresponderles.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">11. Modificaciones</h2>
            <p>
              PreBedAI se reserva el derecho a efectuar sin previo aviso las modificaciones que considere 
              oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios 
              que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados.
            </p>
          </section>

          <section className="mt-12 p-6 bg-gray-50 rounded-lg">
            <h3 className="text-xl font-bold text-[#0A1628] mb-4">Contacto</h3>
            <p>
              Para cualquier consulta o aclaración sobre este Aviso Legal, puede contactarnos en:
            </p>
            <ul className="mt-4 space-y-2">
              <li><strong>Email:</strong> <a href="mailto:info@prebedai.com" className="text-[#6D28D9] hover:underline">info@prebedai.com</a></li>
              <li><strong>Web:</strong> <a href="https://prebedai.com" className="text-[#6D28D9] hover:underline">https://prebedai.com</a></li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
